/* src/app/order/components/company-address/company-address.style.scss */
.margin-bottom20 {
  margin-bottom: 20px !important;
}
.margin-top20 {
  margin-top: 20px !important;
}
.company-input-label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  display: block;
  text-transform: uppercase;
}
.country-input {
  max-width: 90px;
}
.state-input {
  margin: 0 30px 0 0;
}
.additional-fields {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
@media screen and (max-width: 991px) {
  .grouped-inputs {
    flex-wrap: nowrap;
  }
  .grouped-inputs .form-input:not(:last-child) {
    margin-bottom: 20px;
  }
  .additional-fields {
    margin-top: 0;
  }
  .country-input {
    margin-right: 30px;
  }
}
@media screen and (max-width: 560px) {
  .grouped-inputs {
    flex-wrap: wrap;
  }
  .state-input {
    margin-right: 0;
  }
  .country-input {
    margin: 0 0 20px 0;
    max-width: inherit;
  }
  .additional-fields {
    margin-top: 20px;
  }
}
/*# sourceMappingURL=company-address.style.css.map */
